import { makeStyles, Menu, MenuList, MenuPopover, MenuTrigger } from "@fluentui/react-components";
import DesktopSection from "./DesktopSection";
import MenuHeader from "./MenuHeader";
import INavigationSection from "../../../models/navigation/INavigationSection";
import INavigationArea from "../../../models/navigation/INavigationArea";

interface IDesktopAreaProps {
    area: INavigationArea;
}

const useStyles = makeStyles({
    serviceMenuList: {
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: "1rem",
    }
});

export default function DesktopArea(props: IDesktopAreaProps) {
    const { area } = props;
    const styles = useStyles();

    return (
        <Menu positioning={{ autoSize: true }} openOnHover hoverDelay={0}>
            <MenuTrigger disableButtonEnhancement>
                <MenuHeader label={area.name} />
            </MenuTrigger>
            <MenuPopover>
                <MenuList className={styles.serviceMenuList}>
                    {
                        area.sections
                            .sort((a, b) => a.order - b.order)
                            .map((section: INavigationSection) => (
                                <DesktopSection key={section.id} area={area} section={section} />
                            ))
                    }
                </MenuList>
            </MenuPopover>
        </Menu>
    );
}